module.exports = __webpack_public_path__ + "static/media/NEMAPremium.0d1ce99d.png";